import { Component } from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {BaseSectionComponent} from "../base-section/base-section.component";
import {InstagramItemComponent} from "../../elements/instagram-item/instagram-item.component";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {PageTextImagesSection} from "../../../models/Page/Sections/PageTextImagesSection";
import {SocialNetworksComponent} from "../../elements/social-networks/social-networks.component";

@Component({
  selector: 'terre-constrastes-section',
  standalone: true,
  imports: [
    AsyncPipe,
    AttachmentFromIdPipe,
    BaseSectionComponent,
    InstagramItemComponent,
    MediaAttachmentComponent,
    NgForOf,
    NgIf,
    SafeHtmlPipe,
    SocialNetworksComponent
  ],
  templateUrl: './terre-constrastes-section.component.html',
  styleUrl: './terre-constrastes-section.component.scss'
})
export class TerreConstrastesSectionComponent extends BaseSectionComponent<PageTextImagesSection>{

}
